<div class="user-card" [@dataChange]="dataState" (@dataChange.done)="dataState = DataState.DONE">
  <button *ngIf="canFlipCard" (click)="toggleCardView()" mat-icon-button [matTooltip]="getToggleTooltip()" matTooltipPosition="above" class="card-badge-flip">
    <span class="icon-flip"></span>
  </button>
  <div class="card-type" [ngClass]="getCardTypeClass(cardType)">
    <span [ngClass]="cardIcon"></span>
    {{ cardLabel }}
  </div>
  <div class="card-content">
    <div class="user-infos">
      <img class="user-avatar" [src]="photo" alt="avatar">

      <div class="card-base-info-container">
        <div class="card-base-info">
          <div class="user-name-wrap">
            <span class="user-name">{{ firstName }} {{ lastName }}</span>
          </div>
          <span>{{ orgName }}</span>
          <span *ngIf="displayExpDate" class="user-card-expirationDate" [ngClass]="status === CardStatus.PROCESSING || status === CardStatus.ACTIVATING ? 'user-card-expirationDate-processing' : ''">
            {{ expDateString }}
          </span>
        </div>
        <div class="card-badge card-badge-margin-top" *ngIf="canWriteCard && isExpDateUpdatable(cardType)">
          <span class="icon-edit" (click)="updateCardExpDate()"></span>
        </div>
      </div>
    </div>

    <div *ngIf="cardView === CardView.DEFAULT">
      <div class="user-nocard" *ngIf="!status && !canFlipCard">
        <div class="warning-icon">
          <span class="icon icon-warning"></span>
        </div>
        {{ 'pages.user-cards.my-card.no-card-warning' | translate }}
        <article class="button-message article-mb quill-content-wrapper ql-editor" 
          [innerHTML]="instructionsGeneralIntroduction | safeHtml">
        </article>
        <div class="button-wrapper">
          <button *ngIf="creatable" class="bciti-button bciti-button--blue" (click)="subscribeToCard()">
            {{ 'pages.user-cards.common.button.subscribe' | translate }}
          </button>
          <article class="button-message article-mb quill-content-wrapper ql-editor" 
            [innerHTML]="subscribeTooltipButton | safeHtml">
          </article>
        </div>
        <div *ngIf="linkable" class="button-wrapper">
          <button class="bciti-button bciti-button--blue" (click)="linkCard()">
            {{ 'pages.user-cards.common.button.link' | translate }}
          </button>
          <article class="button-message article-mb quill-content-wrapper ql-editor" 
            [innerHTML]="linkTooltipButton | safeHtml">
          </article>
        </div>
      </div>
      <div class="user-card-details" *ngIf="!!card">
        <span class="user-card-status" *ngIf="status === CardStatus.PROCESSING || status === CardStatus.ACTIVATING"
        [ngClass]="status === CardStatus.PROCESSING || status === CardStatus.ACTIVATING ? 'card-status-processing' : ''">
          {{ 'pages.user-cards.common.status.' + status | translate }}
        </span>
        <span class="user-card-status card-status-processing" *ngIf="card.renewal?.status === CardStatus.ACTIVATING">
          {{ 'pages.user-cards.my-card.renewalSyncInProgress' | translate }}
        </span>

        <div class="user-card-renewal-alert" 
            *ngIf="(status === CardStatus.ACTIVE && showExpireSoonMessage && !card.renewal?.number && legacyCardShow) || (!isLegacyCard && status === CardStatus.EXPIRED && !card.renewal?.number && legacyCardShow)">
          <span class="renewal-message" *ngIf="showExpireSoonMessage && !showExpireMessage">
            {{ 'pages.user-cards.my-card.renewal-alert' | translate: {renewalDelay: cardConfig.renewalDelay} }}
          </span>
          <span class="renewal-message" *ngIf="showExpireSoonMessage && showExpireMessage">
            {{ 'pages.user-cards.my-card.expired-alert' | translate: {renewalDelay: cardConfig.renewalDelay} }}
          </span>
          <button *ngIf="canWriteCard" class="bciti-button bciti-button--orange" (click)="renewCard()">
            {{ 'pages.user-cards.common.button.renew' | translate }}
          </button>
        </div>
        <span class="user-organisation-logo">
          <img [src]="orgLogo" alt="">
        </span>
        <!-- TODO: Revisit implementation. It's been disabled in favor of the Flip Card subscription feature. -->
        <!-- <div class="subscriptions-empty-wrap user-nocard" *ngIf="isLegacyCard && !legacyCardShow">
            <p [innerHTML]="'pages.user-cards.my-card.legacy-no-subscriptions' | translate"></p>
            <div class="button-wrapper">

                <button class="bciti-button bciti-button--blue" routerLink="/subscriptions">
                    {{ 'pages.user-cards.my-card.add-subscriptions' | translate }}
                </button>
            </div>
        </div> -->
        <div class="user-card-barcode" *ngIf="[CardStatus.ACTIVE, CardStatus.EXPIRED].includes(status) && !_loading && showCardInfo">
           <div *ngIf="status === CardStatus.EXPIRED && (isLegacyCard || card.renewal?.number)" class="user-card-renewal-alert">
              {{ 'pages.user-cards.my-card.expired-alert' | translate }}
            </div>
          <div *ngIf="cardConfig.barcode === BardCodeType.QRCODE && showCardInfo">
            <ngx-qrcode 
              id="qrcode" 
              [elementType]="qrcodeOpt.elementType" 
              [errorCorrectionLevel]="qrcodeOpt.correctionLevel" 
              [value]="qrCodeForImage"
            ></ngx-qrcode>
          </div>
          <div *ngIf="cardConfig.barcode === BardCodeType.BARCODE && showCardInfo">
            <ngx-barcode6 
              bc-format="CODE39" 
              bc-width=1 
              [bc-value]="code" 
              [bc-display-value]="false"
            ></ngx-barcode6>
          </div>
          <img class="display-none" id='barcode'>
          <span *ngIf="showCardInfo">{{ code }}</span>
          <div class="card-subtype" *ngIf="subTypeName" [ngStyle]="{'background-color': subTypeColor}">
            {{subTypeName}}
          </div>
          <div class="user-card-syst-ext" *ngIf="cardConfig.linkSystExt">
            <!-- this feature is depracated but we keep the button for future improvment if needed -->
            <!-- <button mat-button class="bciti-button" [ngClass]="getSystExtLinkButtonClass(cardType)" (click)="systExtLink()">
              {{ 'pages.user-cards.my-card.systExtLinkButton' | translate }}
            </button> -->
          </div>
        </div>
        <div *ngIf="status === CardStatus.ACTIVE && showCardInfo" class="print-btn">
          <button [disabled]="cardPrintLoading" mat-icon-button class="card-badge" (click)="printCard()" [matTooltip]="getPrintTooltip()">
            <span *ngIf="!cardPrintLoading" class="no-margin icon-print-text"></span>
            <span *ngIf="cardPrintLoading">
              <mat-progress-spinner
                mode="indeterminate"
                diameter="20">
              </mat-progress-spinner>
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="subscriptions-wrap" *ngIf="cardView === CardView.SUBSCRIPTIONS">
      <h4 *ngIf="subscriptions.length">{{ 'pages.user-cards.my-card.subscriptions' | translate }}</h4>
      <div class="subscription" *ngFor="let sub of subscriptions">
        <div class="icon">
          <span [ngClass]="sub.icon"></span>
        </div>
        <div class="info">
          <p class="name">{{ sub.name }} | {{ getSubscriptionTypeText(sub.subscriptionType) }}</p>
          <p class="code">{{ getSubscriptionCode(sub) }}</p>
        </div>
        <div class="expiration">
          <span class="expired" *ngIf="isExpired(sub.endDate)">
            {{ 'pages.user-cards.subscription.expired' | translate }}
          </span>
          <span *ngIf="!isExpired(sub.endDate)">
            {{ 'pages.user-cards.subscription.exp' | translate }}<br />{{ formatDateUTC(sub.endDate) }}
          </span>
        </div>
      </div>
      <div class="subscriptions-empty-wrap" *ngIf="!subscriptions.length && canShowSubscriptions">
        <p [innerHTML]="'pages.user-cards.my-card.no-subscriptions' | translate"></p>
        <button class="bciti-inline-button" routerLink="/subscriptions">
          {{ 'pages.user-cards.my-card.subscriptions' | translate }} <span class="icon-search"></span>
        </button>
      </div>
      <div class="print-btn">
        <button [disabled]="cardPrintLoading" mat-icon-button class="card-badge" (click)="printCard()"
          [matTooltip]="getPrintTooltip()">
          <span *ngIf="!cardPrintLoading" class="no-margin icon-print-text"></span>
          <span class="no-margin" *ngIf="cardPrintLoading">
            <mat-progress-spinner mode="indeterminate" diameter="20">
            </mat-progress-spinner>
          </span>
        </button>
        <!-- This is required in order to be able to print card. The print logic relies on this component  -->
        <div class="hiden" *ngIf="cardConfig.barcode === BardCodeType.QRCODE && showCardInfo">
          <ngx-qrcode 
            id="qrcode" 
            [elementType]="qrcodeOpt.elementType"
            [errorCorrectionLevel]="qrcodeOpt.correctionLevel" 
            [value]="qrCodeForImage"
          ></ngx-qrcode>
        </div>
        <div class="hiden" *ngIf="cardConfig.barcode === BardCodeType.BARCODE && showCardInfo">
          <ngx-barcode6 
            bc-format="CODE39" 
            bc-width=1 
            [bc-value]="code" 
            [bc-display-value]="false"
          ></ngx-barcode6>
        </div>
        <img class="display-none" id='barcode'>
      </div>
    </div>
  </div>
</div>